import { sbEditable, type SBProps } from '../../../../utils';

interface SBTableRowProps {
  step?: string;
  title?: string;
  description?: string;
  outcome?: string;
}

export const SBTableRow = ({ blok }: SBProps<SBTableRowProps>) => {
  const { step, title, description, outcome } = blok;

  return (
    <div {...sbEditable(blok)}>
      <div className="grid grid-cols-[74px_auto] gap-x-4 border-b border-gray-200 last:border-0 lg:hidden">
        {step && (
          <div className="pt-4">
            <p className="text-naturaily-cascade mb-2 text-sm font-semibold">Step</p>
            <p className="text-primary-600 text-display-lg-46 font-semibold">{step}</p>
          </div>
        )}
        {(title || description || outcome) && (
          <div className="pb-6 pt-4">
            {(title || description) && (
              <>
                <p className="text-naturaily-cascade mb-2 text-sm font-semibold">What we do</p>
                <h3 className="mb-1 font-semibold text-gray-900">{title}</h3>
                <p className="mb-6 text-sm text-gray-600">{description}</p>
              </>
            )}
            {outcome && (
              <>
                <p className="text-naturaily-cascade mb-2 text-sm font-semibold">What you get</p>
                <p className="text-sm text-gray-600" itemProp="text">
                  {outcome}
                </p>
              </>
            )}
          </div>
        )}
      </div>

      {(title || description || outcome) && (
        <div
          className="hover:border-primary-600 hover:bg-primary-600 group hidden grid-cols-[228px_1fr_1fr] border-b border-gray-300 py-10 transition-all hover:rounded-xl lg:grid"
          itemProp="step"
          itemScope
          itemType="https://schema.org/HowToStep"
        >
          {step && (
            <div className="px-6">
              <p
                className="text-primary-600 text-display-xl-58 font-semibold transition-colors group-hover:text-white"
                itemProp="position"
              >
                {step}
              </p>
            </div>
          )}
          {(title || description) && (
            <div className="flex flex-col gap-y-1 px-10">
              <h3
                className="text-lg font-semibold text-gray-900 transition-colors group-hover:text-white"
                itemProp="name"
              >
                {title}
              </h3>
              <p
                className="text-gray-600 transition-colors group-hover:text-white"
                itemProp="description"
              >
                {description}
              </p>
            </div>
          )}
          {outcome && (
            <div className="px-10">
              <p className="text-gray-600 transition-colors group-hover:text-white" itemProp="text">
                {outcome}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
